module.exports = __webpack_public_path__ + "img/remediation-progress.5d87533.gif";